import React from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Avatar,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useAuth } from "../../contexts/AuthContext";

const stats = [
  {
    label: "Users",
    value: 42,
    icon: <PeopleIcon fontSize="large" />,
    color: "#1976d2",
  },
  {
    label: "Active Contracts",
    value: 19,
    icon: <AssignmentIcon fontSize="large" />,
    color: "#388e3c",
  },
  {
    label: "Alerts",
    value: 3,
    icon: <WarningAmberIcon fontSize="large" />,
    color: "#d32f2f",
  },
];

const Dashboard: React.FC = () => {
  const { idTokenData } = useAuth();
  const userEmail = idTokenData?.email || "User";
  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Typography variant="h3" fontWeight={700} gutterBottom color="primary">
          Global Controls
        </Typography>
        <Typography variant="h5" color="text.secondary">
          Welcome, {userEmail}!
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {stats.map((stat) => (
          <Grid size={{ xs: 12, md: 4 }} key={stat.label}>
            <Card elevation={4} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ textAlign: "center" }}>
                <Avatar
                  sx={{
                    bgcolor: stat.color,
                    width: 56,
                    height: 56,
                    mx: "auto",
                    mb: 2,
                  }}
                >
                  {stat.icon}
                </Avatar>
                <Typography variant="h4" fontWeight={600} color="text.primary">
                  {stat.value}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {stat.label}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Dashboard;
